import * as React from 'react'

import { Block } from 'blocks/block'
import { DPTellitBlock } from 'types/DPTypes'
import css from './tellit.module.scss'
import { fromModule } from 'util/styler/Styler'
import { useEffect } from 'react'

const styles = fromModule(css)

interface Tellit {
	createFirebasePlayer(embedKey: string, selector: string): void
}

let tellit: Promise<Tellit> | undefined

function loadTellit(): Promise<Tellit> {
  const REACT_URL = "https://unpkg.com/react@18/umd/react.production.min.js"
  const REACT_DOM_URL =
    "https://unpkg.com/react-dom@18/umd/react-dom.production.min.js"
  const TELLIT_URL = "https://tellit-imec.netlify.app/tellit.min.js"

  // Helper function to load a script and return a promise
  const loadScript = (src: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      // Check if the script is already on the page
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve()
        return
      }
      const script = document.createElement("script")
      script.src = src
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
      document.head.appendChild(script)
    })
  }

  return (
    Promise.all([loadScript(REACT_URL), loadScript(REACT_DOM_URL)])
      .then(() => loadScript(TELLIT_URL))
      .then(() => window["tellit"])
  )
}

function useTellit(embedKey: string, id: string) {
	useEffect(() => {
		let canceled = false
		tellit ??= loadTellit()
		tellit
			.then(({createFirebasePlayer}) => {
				if (!canceled) createFirebasePlayer(embedKey, `#${id}`)
			})
			.catch(console.error)
		return () => {
			canceled = true
			// Workaround to clean svg set by tellit script so header/footer isn't left with a giant empty space
			document.body.childNodes.forEach((element) => {
				if ((element as any).tagName === 'svg') {
					document.body.removeChild(element)
				}
			})
		}
	}, [embedKey, id])
}

export const Tellit: React.FC<DPTellitBlock> = (data) => {
	const id = `tellit_${data.id}`
	useTellit(data.embed_key, id)
	return <Block type="tellit" className={styles.tellit()} anchorID={id}></Block>
}
